<script setup lang="ts">
import { useSlots } from 'vue';

import { useLoading } from '@/composables/loading';

const props = defineProps<{
  handleLoading?: boolean;
}>();

const { loading } = useLoading();
const slots = useSlots();
</script>

<template>
  <p-dialog
    :close-on-escape="props.handleLoading ? !loading : true"
    :dismissable-mask="props.handleLoading ? !loading : true"
    :close-button-props="(props.handleLoading && loading) ?
      {disabled: true, text: true, rounded: true, severity:'secondary'}
      : undefined"
    modal
    v-bind="$attrs"
    :draggable="false"
    :pt="{ ...(($attrs.pt as object) ?? {}), title: { 'data-test': 'dialog-title' } }"
  >
    <template v-if="slots.header" #header>
      <slot name="header" />
    </template>
    <slot />
    <template v-if="slots.footer" #footer>
      <slot name="footer" />
    </template>
  </p-dialog>
</template>

<style lang="scss">
.p-dialog {
  aspect-ratio: 3/2;
}

.p-dialog .p-dialog-title {
  color: var(--p-secondary-500);
}

.p-dialog .p-dialog-content {
  flex: 1 1 0;
}

/*
  solution for all modals that don't or shouldn't work with 3/2 aspect ratio
  - seat warning
  - confirmation modals
  - user roles (to be replaced / removed)
 */
.p-dialog.aspect-auto {
  .p-dialog-content {
    flex: unset;
  }
}
</style>
